import { render, staticRenderFns } from "./VueDialog.vue?vue&type=template&id=731d8357&scoped=true&"
import script from "./VueDialog.vue?vue&type=script&lang=js&"
export * from "./VueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d8357",
  null
  
)

export default component.exports